import { RemoteLoadUserLocationList } from '@/javascript/data/usecases'
import { LoadUserLocationList } from '@/javascript/domain/usecases'
import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'

export const makeRemoteLoadUserLocationList = (): LoadUserLocationList =>
  new RemoteLoadUserLocationList(makeApiUrl('/maps/user_locations'), makeCurrentAccountHttpClientDecorator())